module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 unnumbered",
    attrs: {
      "id": "الخاتم-العجيب"
    }
  }, [_c('h3', {
    staticStyle: {
      "text-align": "right",
      "padding-top": "150px"
    }
  }, [_vm._v("أحلام يحيى جحاف")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right",
      "font-family": "Sakkal Majalla"
    }
  }, [_c('strong', [_vm._v("كاتبة يمنية.. حاصلة على درجة الماجستير في الإدارة.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right",
      "font-family": "Sakkal Majalla"
    }
  }, [_c('strong', [_vm._v("عملت في مجال التعليم معلِّمة لمادة الرياضيات، ثم انتقلت للعمل مدربة ومعدة أدلَّة وحقائب تدريبية بقطاع التدريب في وزارة التربية والتعليم.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right",
      "font-family": "Sakkal Majalla"
    }
  }, [_c('strong', [_vm._v("نُشر لها عدد من القصص القصيرة مع آخرين في كتابين: \""), _c('em', [_vm._v("خطوات - مبدعون من أجل حقوق الأطفال\"")]), _vm._v(" و\""), _c('em', [_vm._v("خطوات 2")]), _vm._v("\" عبر مؤسسة إبحار للطفولة والإبداع، كما شاركت في عدد من مسابقات القصة القصيرة، ونُشرت لها قصص فائزة في عدد من الكتب الجماعية: "), _c('em', [_vm._v("\"المنفيون إلى جوار السحاب\"")]), _vm._v(" المكتبة العربية للنشر والتوزيع، "), _c('em', [_vm._v("\"صندوق الدنيا\"")]), _vm._v(" لدار زين للنشر والتوزيع، "), _c('em', [_vm._v("\"شموس\"")]), _vm._v(" لدار مها للنشر والتوزيع، و"), _c('em', [_vm._v("\"سبيل الأمم\"")]), _vm._v(" مع مبادرة حلم الوصول.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ec6b73","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0